import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { getCheckoutUrl, getTotalPrice, getBumps, setPopupOpen, subscribe } from '../utils/checkoutStore';
import { trackAddToCart } from '../utils/metaPixel';
export function FinalCTA() {
  const [checkoutUrl, setCheckoutUrl] = useState(getCheckoutUrl());
  const [totalPrice, setTotalPrice] = useState(getTotalPrice());
  useEffect(() => {
    const unsubscribe = subscribe(() => {
      setCheckoutUrl(getCheckoutUrl());
      setTotalPrice(getTotalPrice());
    });
    return unsubscribe;
  }, []);
  return <section className="py-14 md:py-28 px-4" style={{
    backgroundColor: '#F5EDE4'
  }} data-id="element-67">
      <div className="max-w-4xl mx-auto text-center" data-id="element-68">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.6
      }} data-id="element-69">
          <img src="https://cdn.magicpatterns.com/uploads/kBeTzJybmggQbUAVi9skGX/ChatGPT_Image_1_abr_2026,_09_56_40_a.m..jpg" alt="Cinnamon Rolls XL — Edición Coleccionable en tablet y celular" className="w-full max-w-md mx-auto rounded-3xl shadow-xl object-cover mb-8 md:mb-10 max-h-[250px] md:max-h-[380px]" data-id="element-70" />

          <h2 className="text-3xl md:text-6xl font-bold leading-tight mb-4 md:mb-6" style={{
          color: '#1A1614'
        }} data-id="element-71">
            El clásico más amado.
          </h2>

          <div className="space-y-2 mb-8 md:mb-10" data-id="element-72">
            <p className="text-xl md:text-3xl italic" style={{
            color: '#e76f51',
            fontFamily: "'Playfair Display', serif"
          }} data-id="element-73">
              Reinterpretado en formato XL real.
            </p>
            <p className="text-base md:text-xl" style={{
            color: '#5a5248'
          }} data-id="element-74">
              Con método. Con estructura. Con identidad profesional.
            </p>
          </div>

          <button onClick={() => {
          const bumps = getBumps();
          if (!bumps.bump1 && !bumps.bump2) {
            setPopupOpen(true);
          } else {
            trackAddToCart({
              value: totalPrice,
              currency: 'USD'
            });
            window.open(checkoutUrl, '_blank', 'noopener,noreferrer');
          }
        }} className="inline-flex items-center gap-3 font-bold text-lg md:text-xl py-5 md:py-6 px-10 md:px-12 rounded-full transition-all duration-300 w-full sm:w-auto justify-center no-underline" style={{
          backgroundColor: '#e76f51',
          color: '#ffffff',
          boxShadow: '0 8px 32px rgba(231,111,81,0.35)'
        }} onMouseEnter={e => {
          e.currentTarget.style.backgroundColor = '#f08565';
          e.currentTarget.style.transform = 'scale(1.03)';
        }} onMouseLeave={e => {
          e.currentTarget.style.backgroundColor = '#e76f51';
          e.currentTarget.style.transform = 'scale(1)';
        }} data-id="element-75">
            Empieza hoy por solo — ${totalPrice.toFixed(2)} USD
            <ArrowRightIcon className="w-5 h-5 md:w-6 md:h-6" data-id="element-76" />
          </button>
        </motion.div>
      </div>
    </section>;
}